const bind = function (form) {
    $(form).find('.close-flash-message').each(function (e, item) {
        $(item).on('click', function () {
            $(this).closest('div').fadeOut();
        });
    });
}

export {
    bind,
}